import type { Warehouse } from '@/domain';
import { mockStore } from '@/lib/mock-store';
import { getSupabase, isMockBackend } from '@/lib/supabase';

export const warehouseService = {
  async list(): Promise<Warehouse[]> {
    if (isMockBackend) {
      return mockStore.getAll('warehouses');
    }
    const supabase = getSupabase()!;
    const { data, error } = await supabase
      .from('warehouses')
      .select('*')
      .order('code', { ascending: true });
    if (error) throw error;
    return (data ?? []) as Warehouse[];
  },
  async getById(id: string): Promise<Warehouse | null> {
    const all = await this.list();
    return all.find((w) => w.id === id) ?? null;
  },
};
